let newspapersData = history.state;
const productForm = document.querySelector(`product-form form`);

if (newspapersData && Object.keys(newspapersData).length > 0) {
  localStorage.setItem("newspaperData", JSON.stringify(newspapersData));
} else {
  newspapersData = JSON.parse(localStorage.getItem("newspaperData"));
}

// Convert any non-standard locale for newspaper_origin, if present (e.g. "en_GB" to "en-GB")
if (newspapersData && newspapersData.newspaper_origin) {
  newspapersData.newspaper_origin = newspapersData.newspaper_origin.replace(
    /_/g,
    "-",
  );
}

const attachHiddenInput = (propName, attributeName) => {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = propName;
  input.value = newspapersData[attributeName];
  if (productForm) productForm.appendChild(input);
};

const sectionId = document
  .querySelector(`script#original-newspapers`)
  .getAttribute("section");
const priceElements = document.querySelectorAll(`#price-${sectionId}`);
const newspaperPrice = newspapersData.price;
const stepWrapper = document.querySelector("#stepWrapper");
const firstAddonPrice = stepWrapper
  .querySelector(
    '[data-addon-container="first-addon"] input[type="radio"]:checked',
  )
  .getAttribute("data-price");

priceElements.forEach((priceElement) => {
  const priceValue = priceElement.querySelector("[data-price]");
  let total =
    parseFloat(priceValue.getAttribute("data-price")) +
    parseFloat(newspaperPrice) +
    parseFloat(firstAddonPrice);
  priceValue.setAttribute("data-price", total);
  if (total > 0) {
    total = total / 100;
  }
  total = total.toFixed(2);
  priceValue.textContent = `${Shopify.formatMoney(total, window.theme.moneyFormat)} ${window.theme.currency}`;
});

const newspaperTitles = document.querySelectorAll("[data-newspaper-title]");
if (newspaperTitles)
  newspaperTitles.forEach(
    (newspaperTitle) => (newspaperTitle.textContent = newspapersData.name),
  );

const newspaperDates = document.querySelectorAll("[data-newspaper-date]");
if (newspaperDates)
  newspaperDates.forEach(
    (newspaperDate) =>
      (newspaperDate.textContent = parseDate(
        newspapersData.newspaper_date,
      ).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })),
  );

// dateString is YYYYMMDD, create a new Date object
function parseDate(date) {
  const dateString = date.toString();
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);
  return new Date(year, month - 1, day);
}

attachHiddenInput("properties[Media Code]", "media_code");
attachHiddenInput("properties[Newspaper Date]", "newspaper_date");
attachHiddenInput("properties[Newspaper Title]", "name");
attachHiddenInput("properties[Newspaper Origin]", "newspaper_origin");
attachHiddenInput("properties[Newspaper Rate]", "newspaper_rate");
attachHiddenInput("properties[Newspaper Currency]", "newspaper_currency");
attachHiddenInput("newspaper_id");
attachHiddenInput("newspaper_name");
attachHiddenInput("properties[HN Newspaper Price]", "price");
attachHiddenInput("properties[Newspaper Quantity]", "qty");
attachHiddenInput("image_url");
